import {announce} from '@github-ui/aria-live'
import {LABELS} from '@github-ui/issues-shared/labels'
import {useMutation, useQueryClient} from '@github-ui/react-query'

import type {CreateSavedViewResponse, DuplicateSavedViewVariables} from '../components/views/types'
import {
  primeSavedViewCaches,
  type SavedViewMutationOptions,
  sendSavedViewMutationJson,
} from '../utils/saved-view-mutations'

export function useDuplicateSavedViewMutation({owner, repo}: SavedViewMutationOptions) {
  const queryClient = useQueryClient()

  return useMutation<CreateSavedViewResponse, Error, DuplicateSavedViewVariables>({
    mutationFn: ({view, name}) =>
      sendSavedViewMutationJson<CreateSavedViewResponse>(
        `/${owner}/${repo}/issues/views.json`,
        {
          method: 'POST',
          body: {
            name,
            query: view.query,
            description: view.description ?? undefined,
            icon: view.icon,
            color: view.color,
            source: 'duplicate',
          },
        },
        LABELS.views.duplicateError,
      ),
    onSuccess: ({savedView}) => primeSavedViewCaches({queryClient, owner, repo}, savedView),
    onError: () => announce(LABELS.views.duplicateError, {assertive: true}),
  })
}
